class CartDrawer extends HTMLElement {
  constructor() {
    super();
    // Store bound handlers for proper cleanup
    this.boundHandlers = {
      onEscape: (evt) => evt.code === 'Escape' && this.close(),
      onOverlayClick: this.close.bind(this),
      cartLinkClicks: [],
      cartLinkKeydowns: []
    };
    this.addEventListener('keyup', this.boundHandlers.onEscape);
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.boundHandlers.onOverlayClick);
    this.setHeaderCartIconAccessibility();
  }

  // Cleanup when element is removed from DOM
  disconnectedCallback() {
    this.removeEventListener('keyup', this.boundHandlers.onEscape);
    this.querySelector('#CartDrawer-Overlay')?.removeEventListener('click', this.boundHandlers.onOverlayClick);
    
    // Remove cart link event listeners
    const cartLinks = document.querySelectorAll('.action_cart');
    cartLinks.forEach((item, index) => {
      if (this.boundHandlers.cartLinkClicks[index]) {
        item.removeEventListener('click', this.boundHandlers.cartLinkClicks[index]);
      }
      if (this.boundHandlers.cartLinkKeydowns[index]) {
        item.removeEventListener('keydown', this.boundHandlers.cartLinkKeydowns[index]);
      }
    });

    // Remove summary accessibility event listeners
    if (this.boundHandlers.summaryElement) {
      this.boundHandlers.summaryElement.removeEventListener('click', this.boundHandlers.summaryClick);
    }
    if (this.boundHandlers.summaryParent) {
      this.boundHandlers.summaryParent.removeEventListener('keyup', this.boundHandlers.summaryKeyup);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelectorAll('.action_cart');
    cartLink.forEach((item, index) => {
      // Store handlers for cleanup
      this.boundHandlers.cartLinkClicks[index] = (event) => {
        event.preventDefault();
        this.open(cartLink);
      };
      this.boundHandlers.cartLinkKeydowns[index] = (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      };
      item.addEventListener('click', this.boundHandlers.cartLinkClicks[index]);
      item.addEventListener('keydown', this.boundHandlers.cartLinkKeydowns[index]);
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    // this.addEventListener(
    //   'transitionend',
    //   () => {
    //     const containerToTrapFocusOn = this.classList.contains('is-empty')
    //       ? this.querySelector('.cart-drawer__inner-empty')
    //       : document.getElementById('CartDrawer');
    //     const focusElement = this.querySelector('.cart-drawer__inner') || this.querySelector('.drawer__close');
    //     // trapFocus(containerToTrapFocusOn, focusElement);
    //   },
    //   { once: true }
    // );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    this.classList.remove('animate');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    // Store handlers for potential cleanup
    if (!this.boundHandlers.summaryClick) {
      this.boundHandlers.summaryClick = (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      };
      this.boundHandlers.summaryKeyup = onKeyUpEscape;
      this.boundHandlers.summaryElement = cartDrawerNote;
      this.boundHandlers.summaryParent = cartDrawerNote.parentElement;
    }

    cartDrawerNote.addEventListener('click', this.boundHandlers.summaryClick);
    cartDrawerNote.parentElement.addEventListener('keyup', this.boundHandlers.summaryKeyup);
  }

  renderContents(parsedState) {
    this.querySelector('.cart-drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.cart-drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      // {
      //   id: 'cart-icon-bubble',
      // },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

// Ensure overflow-hidden is removed when page becomes visible (fixes iOS Safari issues)
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && !cartDrawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
    }
  }
});

// Cleanup on page unload/navigation
window.addEventListener('beforeunload', function() {
  document.body.classList.remove('overflow-hidden');
});

// Fix for back button navigation (especially on mobile)
window.addEventListener('pageshow', function(event) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer && !cartDrawer.classList.contains('active')) {
    document.body.classList.remove('overflow-hidden');
  }
});

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.cart-drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.active_cart',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
